export default "__VITE_ASSET__CsWcCXLx__"